import React from "react";
import {
  Button, CircularProgress,
} from "@mui/material";

interface IProps {
  children: any;
  onClick?(): void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
}

const ButtonLoading = ({children, onClick, disabled, type, ...rest}: IProps) => (
  <Button {...rest} onClick={onClick} type={type} disabled={disabled} variant="contained">
    {disabled ? (
      <CircularProgress size={24} color="primary"/>
    ) : children}
  </Button>
);

export default ButtonLoading;
